import { types } from './types';
import { instance } from '../utils';
import { triggerNotification } from '../../components';
import { triggerLoading } from '../forms/actions';

export const fetchOrganizationsByUser = (userId) => dispatch => {
  const url = `/api/organizations/${userId}/organizationByUser`;
  dispatch({ type: types.SET_ORGANIZATIONS.START });
  dispatch(triggerLoading(true));
  instance
  .get(url)
  .then(response => {
    dispatch({ type: types.SET_ORGANIZATIONS.SUCCESS, payload: response.data });
  })
  .catch(error => {
    dispatch({ type: types.SET_ORGANIZATIONS.ERROR, payload: error.message });
  });
  dispatch(triggerLoading(false));
}

export const createOrganization = (payload, user) => dispatch => {
  const url = `/api/organizations`;
  const headers = {
    "Content-Type": "application/json",
    'Authorization': `Bearer ${user.token}`
  }
  dispatch({ type: types.CREATE_ORGANIZATION.START });
  instance
  .post(url, payload, { headers })
  .then(response => {
    dispatch({ type: types.CREATE_ORGANIZATION.SUCCESS, payload: response.data });
    triggerNotification({
      message: "Creation was successful",
      description: "Organization successfully created",
      status: 'Success',
    });
    dispatch(fetchOrganizationsByUser(user.userId))
  })
  .catch(error => {
    dispatch({ type: types.CREATE_ORGANIZATION.ERROR, payload: error.message });
    triggerNotification({
      message: "Error",
      description: error.message,
      status: 'Error',
    });
  });
}

export const deleteOrganization = (id, user) => dispatch => {
  const url = `/api/organizations/${id}`;
  const headers = {
    "Content-Type": "application/json",
    'Authorization': `Bearer ${user.token}`
  }
  dispatch({ type: types.DELETE_ORGANIZATION.START });
  instance
  .delete(url, { headers })
  .then(response => {
    dispatch({ type: types.DELETE_ORGANIZATION.SUCCESS, payload: response.data });
    dispatch(fetchOrganizationsByUser(user.userId))
  })
  .catch(error => {
    dispatch({ type: types.DELETE_ORGANIZATION.ERROR, payload: error.message });
    triggerNotification({
      message: "Error",
      description: error.message,
      status: 'Error',
    });
  });
}

export const fetchUsersData = (user, orgId) => dispatch => {
  const url = `/api/user/usersData`;
  const headers = {
    "Content-Type": "application/json",
    'Authorization': `Bearer ${user.token}`
  }
  dispatch({ type: types.SET_USERS_DATA.START });
  instance
  .post(url, {orgId}, { headers })
  .then(response => {
    dispatch({ type: types.SET_USERS_DATA.SUCCESS, payload: response.data });
  })
  .catch(error => {
    dispatch({ type: types.SET_USERS_DATA.ERROR, payload: error.message });
  });
}

export const updateOrganizationInternalCategories = (user, orgId, category) => dispatch => {
  const url = `/api/organizations/updateOrganizationInternalCategories`;
  const headers = {
    "Content-Type": "application/json",
    'Authorization': `Bearer ${user.token}`
  }
  dispatch({ type: types.UPDATE_ORG_INT_CATEGORIES.START });
  const body = {
    user, 
    id: orgId, 
    option: category
  }
  instance
  .post(url, body, { headers })
  .then(response => {
    dispatch({ type: types.UPDATE_ORG_INT_CATEGORIES.SUCCESS, payload: response.data });
  })
  .catch(error => {
    dispatch({ type: types.UPDATE_ORG_INT_CATEGORIES.ERROR, payload: error.message });
  });
}
